/**
 * Sections & Tables Module Exports
 */

export { SectionsAndTablesPage } from './SectionsAndTablesPage';
